<template>
  <div
    class="optionContainerBox"
    :class="{ 'optionContainerBox--hidden': $parent.isHeaderHidden }"
  >
    <div class="optionContainer flex acenter">
      <!-- 商品分类 -->
      <el-popover
        placement="bottom"
        popper-class="goodsClassifyBoxPopover"
        trigger="click"
      >
        <div class="goodsClassifyListBox" @click="visible = false">
          <div class="goodsClassifyList" @click.stop>
            <!-- 左侧一级分类导航栏 -->
            <div class="left">
              <div
                class="leftItem"
                v-for="(item, index) in lists"
                :key="item.id"
                :class="{ active: selectedCategory === index }"
                @click="selectCategory(index)"
                @mouseenter="hoverCategory(index)"
                @mouseleave="leaveCategory(index)"
              >
                <!-- 分类图标容器（支持默认图标和悬停图标切换） -->
                <div class="leftItemIcon">
                  <img :src="item.default_icon" alt="" />
                  <!-- 默认图标 -->
                  <img :src="item.trigger_icon" alt="" />
                  <!-- 悬停/选中时的图标 -->
                </div>
                <!-- 分类标题（支持中英文切换） -->
                <div class="leftItemTitle">
                  {{
                    !$store.state.showChinese
                      ? item.translation_name
                      : item.chinese_name
                  }}
                </div>
              </div>
            </div>
            <!-- 右侧二级分类内容区域 -->
            <div class="right">
              <!-- 右侧标题区域 -->
              <div class="rightHeader">
                <h2>{{ getSelectedCategoryName() }}</h2>
              </div>
              <!-- 二级分类网格容器 -->
              <div class="rightContent">
                <!-- 二级分类项目 -->
                <div
                  class="rightItem"
                  v-for="subItem in getSelectedCategoryChildren()"
                  :key="subItem.id"
                  @click="selectSubCategory(subItem)"
                  @mouseenter="hoverSubCategory(subItem)"
                  @mouseleave="leaveSubCategory(subItem)"
                  :class="{
                    active: hoveredSubCategory === subItem.id,
                  }"
                >
                  <!-- 二级分类名称（支持中英文切换） -->
                  {{
                    !$store.state.showChinese
                      ? subItem.translation_name
                      : subItem.chinese_name
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="optionItem goodsClassifyBox"
          slot="reference"
          :class="{ active: visible }"
          @click="visible = !visible"
        >
          <goodsClassify class="goodsClassifyIcon" />
          <span>{{ $fanyi("所有产品") }}</span>
          <arrow class="arrowDown" />
        </div>
      </el-popover>

      <!-- 用户指南 -->
      <div class="optionItem" @click="$fun.routerToPage('/Manuale-utente')">
        <img
          :src="require('@/assets/hometop/topicon (1).svg')"
          alt=""
          class="goodsClassifyIcon"
        />
        <span>{{ $fanyi("用户指南") }}</span>
      </div>
      <div class="line"></div>

      <!-- 国际运输详情 -->
      <!-- <div class="optionItem transportDetails">
        <span>{{ $fanyi("国际运输详情") }}</span>
        <icon1 />
      </div>
      <div class="line"></div> -->

      <!-- 会员等级 -->
      <div class="optionItem" @click="$fun.routerToPage('/Livello-utente')">
        <img
          :src="require('@/assets/hometop/topicon (5).svg')"
          alt=""
          class="goodsClassifyIcon"
        />
        <span>{{ $fanyi("会员等级") }}</span>
      </div>
      <div class="line"></div>

      <!-- 附加服务费用 -->
      <el-popover
        placement="bottom"
        :width="220"
        trigger="click"
        popper-class="optionJumpPopover"
      >
        <div class="option-item-list">
          <div
            class="option-item-list-item"
            @click="$fun.routerToPage('/Costi-dei-servizi-extra')"
          >
            <span>{{ $fanyi("附加服务费用") }}</span>
          </div>
          <div
            class="option-item-list-item"
            @click="$fun.routerToPage('/Servizi-fotografici')"
          >
            <span>{{ $fanyi("摄影服务") }}</span>
          </div>
        </div>
        <template #reference>
          <div class="optionItem">
            <img
              :src="require('@/assets/hometop/topicon (4).svg')"
              alt=""
              class="goodsClassifyIcon"
            />
            <span>{{ $fanyi("附加服务费用") }}</span>
          </div>
        </template>
      </el-popover>
      <div class="line"></div>

      <!-- FAQ -->
      <div class="optionItem" @click="$fun.routerToPage('/FAQ')">
        <img
          :src="require('@/assets/hometop/topicon (3).svg')"
          alt=""
          class="goodsClassifyIcon"
        />
        <span>FAQ</span>
      </div>
      <div class="line"></div>

      <!-- Contatti -->
      <div
        class="optionItem"
        @click="
          $fun.routerToPage('https://www.rakumart.it/Assistenza-clienti', true)
        "
      >
        <img
          :src="require('@/assets/hometop/Contatti.svg')"
          alt=""
          class="goodsClassifyIcon"
        />
        <span>Contatti</span>
      </div>
    </div>
  </div>
</template>
<script>
import arrow from "../assets/arrow.vue";
import goodsClassify from "../assets/goodsClassify.vue";
import { ensureShopGroupCategories } from "@/utlis/shopGroupRoute";
export default {
  props: {},
  data() {
    return {
      lists: [], // 商品分类列表数据
      selectedCategory: 0, // 当前选中的一级分类索引
      hoveredCategory: null, // 当前悬停的一级分类索引
      hoveredSubCategory: null, // 当前悬停的二级分类ID
      visible: false,
    };
  },
  components: {
    arrow,
    goodsClassify,
  },
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    // 复用全局缓存的分类数据，避免重复请求 getShopGroup
    getData() {
      ensureShopGroupCategories().then((data) => {
        if (!data || !data.length) return;
        this.changeData(data);
        this.lists = data;
      });
    },
    changeData(data) {
      //console.log("分类数据", data);
      data.forEach((data1Item) => {
        data1Item.childs.sort(duiBi);
      });
      function duiBi(a, b) {
        // time 是时间的字段 a-b 正序 b-a 倒序
        return Date.parse(b.sort) - Date.parse(a.sort);
      }

      //console.log("排序后", data);
    },
    /**
     * 点击一级分类：跳转到 /一级slug 自定义路由
     */
    selectCategory(index) {
      this.selectedCategory = index;
      const item = this.lists[index];
      // if (item) {
      //   this.$fun.navigateToShopGroupCategory(item);
      // }
    },
    /**
     * 鼠标悬停一级分类
     * @param {number} index - 分类索引
     */
    hoverCategory(index) {
      this.hoveredCategory = index; // 设置悬停的分类索引
    },
    /**
     * 鼠标离开一级分类
     * @param {number} index - 分类索引
     */
    leaveCategory(index) {
      this.hoveredCategory = null; // 清除悬停状态
    },
    /**
     * 点击二级分类：跳转到 /一级slug/二级slug
     * ancestors 传入当前选中的一级分类，用于拼接完整路径
     */
    selectSubCategory(subItem) {
      const parent = this.lists[this.selectedCategory];
      this.$fun.navigateToShopGroupCategory(subItem, parent ? [parent] : []);
    },
    /**
     * 鼠标悬停二级分类
     * @param {Object} subItem - 二级分类对象
     */
    hoverSubCategory(subItem) {
      this.hoveredSubCategory = subItem.id; // 设置悬停的二级分类ID
    },
    /**
     * 鼠标离开二级分类
     * @param {Object} subItem - 二级分类对象
     */
    leaveSubCategory(subItem) {
      this.hoveredSubCategory = null; // 清除悬停状态
    },
    /**
     * 获取当前选中分类的名称
     * @returns {string} 分类名称（根据语言设置返回中文或英文）
     */
    getSelectedCategoryName() {
      if (this.lists.length > 0 && this.selectedCategory < this.lists.length) {
        const item = this.lists[this.selectedCategory];
        // 根据语言设置返回对应的名称
        return !this.$store.state.showChinese
          ? item.translation_name
          : item.chinese_name;
      }
      return "一级分类标题"; // 默认标题
    },
    /**
     * 获取当前选中分类的子分类列表
     * @returns {Array} 子分类数组
     */
    getSelectedCategoryChildren() {
      if (this.lists.length > 0 && this.selectedCategory < this.lists.length) {
        return this.lists[this.selectedCategory].childs || []; // 返回子分类数组，如果没有则返回空数组
      }
      return []; // 默认返回空数组
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.optionContainerBox {
  width: 100%;
  background: #fff;
  padding-bottom: 1px;
  transition: all 0.3s ease; // 添加平滑过渡动画

  // 隐藏状态样式
  &.optionContainerBox--hidden {
    height: 0;
    overflow: hidden;
    padding-bottom: 0;
  }
}

.optionContainer {
  width: 1400px;
  margin: 0 auto 12px;

  .optionItem {
    @extend .dip;
    min-height: 48px;
    border-radius: 6px;
    opacity: 1;
    padding: 12px 24px;
    z-index: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    .goodsClassifyIcon {
      margin-right: 5px;
    }
  }
  .optionItem.goodsClassifyBox {
    background: #eaf8e8;
    color: #009246;
    padding: 12px;
    width: 240px;
    span {
      margin: 0 12px 0 0px;
    }
    .goodsClassifyIcon {
      fill: #009246;
    }
    .arrowDown {
      fill: #009246;
      transition: rotate 0.3s ease;
    }
  }
  .optionItem.goodsClassifyBox.active {
    background-color: #009246;
    color: #fff;
    .goodsClassifyIcon {
      fill: #fff;
    }
    .arrowDown {
      fill: #fff;
      rotate: 180deg;
    }
  }

  .optionItem.transportDetails {
    color: #009246;

    span {
      margin-right: 10px;
    }
  }
  .line {
    width: 1px;
    height: 16px;
    background: #dedede;
  }
}

/* 商品分类弹出框容器 */
.goodsClassifyListBox {
  height: 600px;
  @extend .dip;
  /* 分类列表主容器 */
  .goodsClassifyList {
    width: 1400px;
    height: 100%;
    display: flex; /* 使用flex布局实现左右分栏 */
    background: #fff;
    overflow: auto;

    /* 左侧一级分类导航栏 */
    .left {
      width: 256px;
      background: #fff;
      border-right: 1px solid #f0f0f0; /* 右侧分割线 */
      overflow-y: auto; /* 内容超出时显示垂直滚动条 */

      /* 一级分类项目 */
      .leftItem {
        display: flex;
        align-items: center;
        padding: 16px 15px;
        width: 240px;
        min-height: 54px;
        cursor: pointer;
        transition: all 0.3s ease; /* 添加过渡动画效果 */

        /* 悬停和选中状态样式 */
        &:hover,
        &.active {
          background: #eaf8e8; /* 柔和的绿色背景 */
          color: #009246; /* 绿色文字 */

          /* 图标切换效果：隐藏默认图标，显示悬停图标 */
          .leftItemIcon img:first-child {
            display: none;
          }
          .leftItemIcon img:last-child {
            display: block;
          }
        }

        /* 分类图标容器 */
        .leftItemIcon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
          position: relative; /* 为绝对定位的子元素提供参考 */

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            position: absolute; /* 绝对定位，实现图标重叠 */
            top: 0;
            left: 0;
          }

          /* 默认显示第一个图标（默认图标） */
          img:first-child {
            display: block;
          }

          /* 默认隐藏第二个图标（悬停图标） */
          img:last-child {
            display: none;
          }
        }

        /* 分类标题样式 */
        .leftItemTitle {
          font-size: 16px;
          font-weight: normal;
          line-height: 22px;
          white-space: nowrap; /* 文本不换行 */
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
      }
    }

    /* 右侧二级分类内容区域 */
    .right {
      flex: 1; /* 占据剩余空间 */
      padding: 0 30px;
      background: #fff;

      /* 右侧标题区域 */
      .rightHeader {
        h2 {
          font-size: 20px;
          line-height: 54px;
          font-weight: bold;
          color: #000000;
          margin: 0;
        }
      }

      /* 二级分类网格容器 */
      .rightContent {
        display: grid; /* 使用CSS Grid布局 */
        grid-template-columns: repeat(
          auto-fill,
          minmax(200px, 1fr)
        ); /* 自适应列数，最小200px */
        gap: 0 40px; /* 网格间距 */

        /* 二级分类项目 */
        .rightItem {
          width: 240px;
          height: 56px;
          padding: 0 15px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease; /* 添加过渡动画效果 */
          font-size: 16px;
          line-height: 22px;
          color: #000000;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: flex-start; /* 内容左对齐，避免间距过大 */
          text-align: left; /* 确保文本左对齐 */
          /* 悬停和选中状态 */
          &:hover,
          &.active {
            background: #eaf8e8; /* 柔和的绿色背景 */
            color: #009246; /* 绿色文字 */
            border-color: #009246; /* 绿色边框 */
          }
        }
      }
    }
  }
}

/* 自定义滚动条样式 */
.left::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.left::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道背景色 */
}

.left::-webkit-scrollbar-thumb {
  background: #c1c1c1; /* 滚动条滑块颜色 */
  border-radius: 8px; /* 滑块圆角 */
}

.left::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; /* 悬停时的滑块颜色 */
}

.option-item-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.option-item-list-item {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  padding: 10px;
  cursor: pointer;
  &:hover {
    color: #009246;
    background: #eaf8e8;
  }
}
</style>
<style lang="scss">
.el-popper.goodsClassifyBoxPopover {
  padding-top: 32px;
  margin-top: 0;
  box-shadow: none;
  border: none;
  left: 0;
  right: 0;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  .popper__arrow {
    display: none;
  }
}

.el-popper.optionJumpPopover {
  padding: 10px;
  margin-top: 0;
  box-shadow: none;
  border: none;
  left: 0;
  right: 0;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  .popper__arrow {
    display: none;
  }
}
</style>
